import React from 'react';
import { Link } from 'react-router-dom';

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
    return (
        <div
            className={`fixed top-0 left-0 h-screen w-64 bg-[#12392B] text-white p-4 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
                } sm:translate-x-0 sm:static sm:w-64 transition-transform duration-300 ease-in-out z-50`}
        >
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">Admin Panel</h2>
                <button
                    className="sm:hidden text-white hover:text-[#E6A71A] focus:outline-none"
                    onClick={toggleSidebar}
                    aria-label="Close sidebar"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>
            </div>
            <nav>
                <ul>
                    <li className="mb-2">
                        <Link
                            to="/admin/events"
                            className="block p-2 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition"
                            onClick={toggleSidebar} // Close sidebar on link click in mobile
                        >
                            <div className="flex items-center">
                                <svg
                                    className="w-5 h-5 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                </svg>
                                Events
                            </div>
                        </Link>
                    </li>
                    <li className="mb-2">
                        <Link
                            to="/admin/gallery"
                            className="block p-2 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition"
                            onClick={toggleSidebar}
                        >
                            <div className="flex items-center">
                                <svg
                                    className="w-5 h-5 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                    />
                                </svg>
                                Gallery
                            </div>
                        </Link>
                    </li>
                    <li className="mb-2">
                        <Link
                            to="/admin/packages"
                            className="block p-2 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition"
                            onClick={toggleSidebar}
                        >
                            <div className="flex items-center">
                                <svg
                                    className="w-5 h-5 mr-2"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                    />
                                </svg>
                                Packages
                            </div>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default AdminSidebar;